const o = {
  color: {
    divider: {
      charcoal: "#314351ff",
      clay: "#ded5d1ff"
    }
  }
};
export {
  o as floatingToolbar
};
